import script from "./bornTemp.vue?vue&type=script&setup=true&lang=js"
export * from "./bornTemp.vue?vue&type=script&setup=true&lang=js"

import "./bornTemp.vue?vue&type=style&index=0&id=8e3244fc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8e3244fc"]])

export default __exports__